import Cookies from 'universal-cookie';
import axios from 'axios';

const cookies = new Cookies();


// Heap loading
function heapLoad() {
  window.heap = window.heap || [], heap.load = function(e, t) { window.heap.appid = e, window.heap.config = t = t || {};let r = document.createElement("script");r.type = "text/javascript", r.async = !0, r.src = `https://cdn.heapanalytics.com/js/heap-${e}.js`;let a = document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r, a);for (let n = function(e) { return function() { heap.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; }, p = ["addEventProperties", "addUserProperties", "clearEventProperties", "identify", "resetIdentity", "removeEventProperty", "setEventProperties", "track", "unsetEventProperty"], o = 0;o<p.length;o++)heap[p[o]] = n(p[o]); };
  heap.load(parseInt(HEAP_APP_ID));
}

function heapTracks() {
  // Setting user properties
  let user_heap = cookies.get('user_heap');
  if (user_heap) {
    setUserHeapProps(user_heap);
  }
  else {
    axios.get('/api/v1/influencers/users/heap_user_props')
      .then(({ data }) => {
        let user_heap = data.user;
        setUserHeapProps(user_heap);
      }).catch(err => {
        console.log(err);
      });
  }
}

function setUserHeapProps(user_heap) {
  if (user_heap) {
    cookies.set('user_heap', user_heap);
    heap.addUserProperties({ 'user_id': user_heap.id,
      'agent_id': user_heap.agent_id,
      'email': user_heap.email,
      'admin': user_heap.admin,
      'tech_admin': user_heap.tech_admin,
      'product_admin': user_heap.product_admin,
      'csm_admin': user_heap.csm_admin,
      'csa_admin': user_heap.csa_admin,
      'csc_admin': user_heap.csc_admin });
  }
}

if (window.location.hostname != 'localhost') {
  heapLoad();
  heapTracks();
}

export function setEventProps(event_props) {
  if (window.heap) {
    window.heap.clearEventProperties();
    window.heap.addEventProperties(event_props);
  }
}

export function addHeapProps(new_props) {
  window.heap.addUserProperties(new_props);
}
